import React, { useState } from "react";
import { Grid, Button, makeStyles } from "@material-ui/core";
import CustomSelect from "components/custom/CustomSelect";
import RightSideDrawer from "../RightSideDrawer";
import { Field, Form, Formik } from "formik";
import InputField from "components/ui/form/InputField";
import { ROUTES_VAR, ROUTE_NAME } from "shared/constants";
import { KisshtDialog } from "../../custom/KisshtDialog";
import SoftDelete from "shared/components/softdelete";
import Lowprioritysmblocked from "shared/components/lowprioritysmblocked";
import { PERMISSIONS } from "../../../shared/constants";
import KisshtButton from "components/ui/KisshtButton";
import InfoIcon from '@material-ui/icons/Info';
import { orange } from "@material-ui/core/colors";
import Tooltip from "@material-ui/core/Tooltip";
import CallingInterface from '../../../shared/components/CallingInterfaceModal'
import PermissionInputField from "components/ui/PermissionInputField";

const useStyle = makeStyles((_) => ({
  root:{
    "& .MuiAlert-root":{
      border:'#fff'
    },
    "& .env-info": {
      color: "#2196f3 !important"
    },
    display: "flex",
    flexWrap: "wrap",
    alignContent: "center"
  },
  search: {
    "&  input": {
      padding: "0.6rem 0.4rem",
      maxWidth: "205px",
      color: "#898C98",
      borderColor: "#E2E5EC",
      fontSize: "0.825rem"
    },
  },
  mobile: {
    "&  input": {
      padding: "0.6rem 0.4rem",
      maxWidth: "205px",
      color: "#898C98",
      borderColor: "#E2E5EC",
      fontSize: "0.825rem",
      marginBottom:"0px"
    },
  },
  chipPrimary: {
    color: orange
  }
}));
export const GlobalHeader = ({showHeaderAction=true}) => {
  const classes = useStyle();
  const [model, setModel] = useState(false);
  const [smBlockedModal, setsmBlockedModal] = useState(false);
  const [openCallingModal, setOpenCallingModal] = useState(false);
  const [mobileNumber , setMobileNumber] = useState("")

  const handleStatus = (e, setFieldValue) => {
    e.persist();
    if (e) {
      let item = e.target.value;
      setFieldValue("search", "");
      setFieldValue("status", item);
    }
  };
  const onChangeMobileNo = (e) =>{
    setMobileNumber(e.target.value)
  }
  const reset_data = (data) => {
    setMobileNumber("")
  }
  const handleSubmit = (values) => {
    let url = "";
    if (values.search) {
      switch (values.status) {
        case ROUTE_NAME.user:
          url = `${ROUTES_VAR.users}/${values.search}`;
          break;
        case ROUTE_NAME.loan:
          url = `${ROUTES_VAR.loans}/${values.search}`;
          break;
        case ROUTE_NAME.payment:
          url = `${ROUTES_VAR.payments}/${values.search}`;
          break;
        case ROUTE_NAME.transaction:
          url = `${ROUTES_VAR.transactions}/${values.search}`;
          break;
        default:
          return null;  
      }
    }
    window.open(url, "_blank");
  };

  const onClickModalOpen = () =>{
    setOpenCallingModal(!openCallingModal)
  }
  return (
    <>
      <Formik
        initialValues={{
          status: "",
          search: "",
        
        }}
        
        onSubmit={handleSubmit}
      >
        {({ values, touched, setFieldValue }) => (
          <Form className="w-full" >
            <Grid container alignItems="center" className="mobile_head_panel">
              <Grid item xs={12} sm={12} md={10} className="for_mobile_space">
                <Grid container spacing={1}>
                  {showHeaderAction && <>
                    <Grid item className={`${classes.root} `}>
                      <CustomSelect
                        onChange={(e) => handleStatus(e, setFieldValue)}
                        multiple={false}
                        nulloption="Search By"
                        value={values.status}
                        options={{
                          transaction: "Transaction Reference no",
                          user: "User Reference No",
                          loan: "Loan Reference No",
                          payment: "Payment Reference No",
                        }}
                        className="common_global_filter"
                      />
                    </Grid>
                    <Grid item className={`${classes.root} global-search-input `}>
                      <Field
                        variant="outlined"
                        className={`${classes.search} common_custom_input`}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        id="search"
                        placeholder="Search"
                        name="search"
                        component={InputField}
                        touched={touched}
                        value={values.search}
                        
                      />
                    </Grid>
                    <Grid item className={classes.root}>
                      <Button
                        disabled={values.search && values.status ? false : true}
                        variant="contained"
                        className="shadow-none common_kissht_btn"
                        color="primary"
                        size="medium"
                        type="submit"
                      >
                        Search
                    </Button>
                    </Grid>
                    <Grid item className={`${classes.root} global-search-input `}>
                      <PermissionInputField
                        variant="outlined"
                        className={`${classes.mobile} common_custom_input`}
                        size="small"
                        // InputLabelProps={{ shrink: true }}
                        id="mobile"
                        placeholder="Enter Mobile Number"
                        name="mobile"
                        component={InputField}
                        maxlength={10}
                        type="number"   
                        onInput={(e) => {e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0,10)}}
                        onChange={(e) => onChangeMobileNo(e)}
                        route={ROUTE_NAME.global_header}
                        permission={PERMISSIONS.global_header.click_to_call}
                        // touched={touched}
                        value={mobileNumber}
                      />
                    </Grid>
                    <Grid item className={classes.root}>
                      <KisshtButton
                        variant="contained"
                        className="shadow-none common_kissht_btn"
                        color="primary"
                        size="medium"
                        disabled={mobileNumber.length != 10 ? true : false}
                        route={ROUTE_NAME.global_header}
                        permission={PERMISSIONS.global_header.click_to_call}
                        onClick={() => onClickModalOpen()}
                      >
                        Call
                    </KisshtButton>
                     {/* <Button
                      style={{background:'none',color:'#430B9C'}}
                      onClick={() => merchantOfferMapEdit(cell)}
                      route={ROUTE_NAME["promo-offer"]}
                      permission={PERMISSIONS["promo-offer"]?.["offer-map-update"]}
                      startIcon={<AddIcCallIcon />}></Button> */}
                    {/* <AddIcCallIcon style={{cursor: "pointer", fontSize: "18px"}} color="primary"/> */}
                    </Grid>
                    </>
                    }
                  {/* <Grid item>
                    <KisshtButton
                      size="medium"
                      variant="outlined"
                      route={ROUTE_NAME.transaction}
                      permission={PERMISSIONS.transaction.softDelete}
                      onClick={() => setModel(true)}
                    >
                      Soft Delete
                    </KisshtButton>
                  </Grid> */}
                    
                  <Grid item className={classes.root}>
                    <Tooltip title="Low priority SM Blocked" placement="start-top">
                      <KisshtButton
                        size="medium"
                        variant="outlined"
                        route={ROUTE_NAME.global_header}
                        permission={PERMISSIONS.global_header.low_priority_bulk_upload}
                        onClick={() => setsmBlockedModal(true)}
                        className="common_kissht_btn"
                      >
                        Low Priority Blocked
                      </KisshtButton>
                    </Tooltip>
                  </Grid>
                
                  <Grid item className={classes.root}>
                    {process.env.REACT_APP_STATUS==='Test' && 
                      <Tooltip title={`${process.env.REACT_APP_STATUS} Mode`}>
                        <InfoIcon className="env-info" />
                      </Tooltip>
                    }
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={2} className="mobile_role_section">
                <RightSideDrawer />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
      <KisshtDialog
        maxWidth="sm"
        title="Soft Delete"
        open={model === true}
        handleClose={setModel}
      >
        <SoftDelete handleClose={setModel} />
      </KisshtDialog>
      <KisshtDialog
        maxWidth="sm"
        title="Low Priority SM Blocked"
        open={smBlockedModal === true}
        handleClose={setsmBlockedModal}
      >
        <Lowprioritysmblocked handleClose={setsmBlockedModal} />
      </KisshtDialog>
      <KisshtDialog
        maxWidth="sm"
        title="Click To Call"
        open={openCallingModal === true}
        handleClose={onClickModalOpen}
      >
       <CallingInterface
              visible={openCallingModal}
              resetFunc={reset_data}
              mobileNumber={mobileNumber}
              handleDialogClose={() => onClickModalOpen()}
              />
      </KisshtDialog>    
    </>
  );
};